/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    restrictedMessaging: boolean;
  };
}

const messageContentKey = "messageContent";
export default class ChatInputComponent extends Component<Signature> {
  @action
  onInputChange(event) {
    const message = event.currentTarget.value;
    this.args.changeset.set(messageContentKey, message);
  }
}
